<mat-horizontal-stepper [linear]="true" #stepper>

  <mat-step [stepControl]="centralOfficeForm">
    <ng-template matStepLabel i18n>Central Office</ng-template>
    <div class="form-contents">

      <ng-container>
        <app-central-office (internalCablesChanged)="newInternalCables($event)" [parameters]="parameters" [parentForm]="centralOfficeForm"></app-central-office>
      </ng-container>

    </div>
    <mat-action-row>
      <button type="button" [disabled]="centralOfficeForm.invalid" mat-stroked-button matStepperNext i18n>NEXT</button>
    </mat-action-row>

  </mat-step>

  <mat-step [stepControl]="closureForm">
    <ng-template matStepLabel i18n>Optical Closures</ng-template>
    <div class="form-contents">

      <app-optical-closure-form [parameters]="parameters" [parentForm]="closureForm"></app-optical-closure-form>

    </div>
    <mat-action-row>
      <button mat-button matStepperPrevious i18n>BACK</button>
      <button mat-stroked-button matStepperNext [disabled]="closureForm.invalid" i18n>NEXT</button>
    </mat-action-row>
  </mat-step>

  <mat-step [stepControl]="cableForm">
    <ng-template matStepLabel i18n>Optical Cables</ng-template>
    <div class="form-contents">

      <app-optical-cable #opticalCableComponent [params]="parameters" [parentForm]="cableForm"></app-optical-cable>

    </div>
    <mat-action-row>
      <button mat-button matStepperPrevious i18n>BACK</button>
      <button mat-stroked-button matStepperNext [disabled]="cableForm.invalid" i18n>NEXT</button>
    </mat-action-row>
  </mat-step>

  <mat-step>
    <ng-template matStepLabel i18n>Predefined Parameters</ng-template>
    <div class="form-contents">

      <ng-container *ngIf="stepper.selectedIndex === 3">
        <app-underground></app-underground>
      </ng-container>

    </div>
    <mat-action-row>
      <button mat-button matStepperPrevious i18n>BACK</button>
      <button mat-raised-button color="primary" matStepperNext (click)="finish()"
        [disabled]="centralOfficeForm.invalid || closureForm.invalid || cableForm.invalid" i18n>FINISH</button>
    </mat-action-row>
  </mat-step>

</mat-horizontal-stepper>
